<script lang="ts">
	import isInViewport from 'utils/isInViewport';
	import { onMount } from 'svelte';
	import { throttle } from 'utils/decorators';
	import { getHoldersData } from 'services/coin-data/holders-data';
	import { browser } from '$app/environment';
	import formatNumber from 'utils/formatNumber';

	export let coinName: string;
	export let dark: boolean = false;

	let data;
	let isInUserViewport = false;
	let isLoaded = false;
	let holdersInfoRef;

	async function getHolders() {
		if (!browser) return;

		isLoaded = true;
		data = await getHoldersData(coinName);
	}

	onMount(() => {
		isInUserViewport = isInViewport(holdersInfoRef);
		if (data && isInUserViewport) {
			isLoaded = true;
			getHolders();
		} else {
			document.addEventListener('scroll', handleScroll);
		}

		return () => {
			document.removeEventListener('scroll', handleScroll);
		};
	});

	const handleScroll = throttle(() => {
		isInUserViewport = isInViewport(holdersInfoRef);
	}, 300);

	$: if (isInUserViewport && !isLoaded) {
		isLoaded = true;
		getHolders();
		document.removeEventListener('scroll', handleScroll);
	}
</script>

<section class="wrapper container" class:dark bind:this={holdersInfoRef}>
	{#if data?.totalHolders || data?.top10Holders > 0}
		<h2 class="section-title">{coinName} holders</h2>

		<div class="info-wrapper">
			<div class="info all-holders">
				<p class="title">
					Total holders<span class="value"
						>{data?.totalHolders
							? formatNumber(Number(data?.totalHolders), null, false, 'decimal')
							: 'No data'}</span
					>
				</p>
			</div>
			<div class="info active-holders">
				<p class="title">
					Active holders 24H<span class="value"
						>{data?.activeHolders
							? formatNumber(Number(data?.activeHolders), null, false, 'decimal')
							: 'No data'}</span
					>
				</p>
			</div>
			<div class="info top10">
				<p class="title">
					Top 10 holders<span class="value">
						{data?.top10Holders && data.top10Holders > 0 ? `${data?.top10Holders}%` : 'No data'}
					</span>
				</p>
			</div>
			<div class="info top20">
				<p class="title">
					Top 20 holders<span class="value"
						>{data?.top20Holders && data.top20Holders > 0 ? `${data?.top20Holders}%` : 'No data'}</span
					>
				</p>
			</div>
			<div class="info top50">
				<p class="title">
					Top 50 holders<span class="value"
						>{data?.top50Holders && data.top50Holders > 0 ? `${data?.top50Holders}%` : 'No data'}</span
					>
				</p>
			</div>
			<div class="info top100">
				<p class="title">
					Top 100 holders<span class="value"
						>{data?.top100Holders && data.top50Holders > 0 ? `${data?.top100Holders}%` : 'No data'}</span
					>
				</p>
			</div>
		</div>
	{/if}
</section>

<style lang="scss">
	@import 'coinHoldersInfo';
</style>
